export let LiveSiteClickFulfillmentOrigin = /*#__PURE__*/function (LiveSiteClickFulfillmentOrigin) {
  LiveSiteClickFulfillmentOrigin["FULFILLMENT_TAB"] = "fulfillment tab";
  LiveSiteClickFulfillmentOrigin["CHANGE_ADDRESS"] = "change address";
  LiveSiteClickFulfillmentOrigin["CHANGE_TIME"] = "change time";
  LiveSiteClickFulfillmentOrigin["START_ORDER"] = "start order";
  LiveSiteClickFulfillmentOrigin["CLICK_ITEM_NO_ADDRESS"] = "item was clicked, no address";
  LiveSiteClickFulfillmentOrigin["CLICK_DISH_STATUS_BUTTON_DISH_MODAL"] = "Unavailable menu - click on dish status button in dish modal";
  LiveSiteClickFulfillmentOrigin["CLICK_MENU_STATUS_BUTTON_OLO_PAGE"] = "Unavailable menu - click on menu status button in olo page";
  return LiveSiteClickFulfillmentOrigin;
}({});
export let LivesiteClickFulfillmentStatusDisplayedType = /*#__PURE__*/function (LivesiteClickFulfillmentStatusDisplayedType) {
  LivesiteClickFulfillmentStatusDisplayedType["ACCEPTING_ORDERS"] = "accepting_orders";
  LivesiteClickFulfillmentStatusDisplayedType["CLOSED"] = "closed";
  LivesiteClickFulfillmentStatusDisplayedType["TEMPORARY_CLOSED"] = "temporary closed";
  LivesiteClickFulfillmentStatusDisplayedType["OPENNING_SOON"] = "opening soon";
  LivesiteClickFulfillmentStatusDisplayedType["CLOSING_SOON"] = "closing soon";
  return LivesiteClickFulfillmentStatusDisplayedType;
}({});
//# sourceMappingURL=constants.js.map